import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import axios from 'axios';
import qs from 'qs';

import slugify from '@/slugify';
import App from './App.vue';
import ReportList from './ReportList.vue';
import ReportDetail from './ReportDetail.vue';

/* global gtag */

const axiosInstance = axios.create({
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});
Vue.prototype.$axios = axiosInstance;

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Router);
Vue.mixin({ methods: { toSlug: slugify.toSlug } });


const store = new Vuex.Store({
  state: {
    needReadURLQuery: false,
    intro: null, // HTML snippet to be displayed on top
    accessible: null, // one of (all, prime, white, essential, none)
    tiGroup: null, // Boolean
    enhanced: null, // Boolean
    reports: null, // [] list of report data current being displayed
    detail: null, // single report when hydrated from HTML (not used on nav)
    page: { count: null, currentPage: null, totalPages: null },

    // filters
    terms: [], // filterTerms
    orderBy: 'date', // date | relevance
    filters: {
      types: {},
      technologies: {},
      sectors: {},
      regions: {},
    },
    refMap: {
      type: {
        white_paper: {
          pos: 11,
          label: 'White Paper',
          separator: true,
          def: 'Free research available to anyone who registers for our ‘Connect’ newsletter.',
        },
        essential_read: {
          pos: 12,
          label: 'Essential Reading',
          def: 'A selection of our research available to our ‘Essential’ subscribers.',
        },
        // ti_group: {
        //   pos: 13,
        //   label: 'User Group',
        //   def: 'Exclusive content for members of the Transforma Insights User Group.',
        // },

        Key_Topic_Insight: {
          pos: 0,
          label: 'Key Topic Insight',
          def: 'Cover other interesting and noteworthy topics.',
        },
        Peer_Benchmarking: {
          pos: 1,
          label: 'Peer Benchmarking',
          def: 'Detailed analysis of capabilities of technology vendors in specific fields.',
        },
        Vendor_Insight: {
          pos: 2,
          label: 'Vendor Insight',
          def: "Help enterprises make vendor selection choices by comparing technology vendors' capabilities.",
        },
        Forecast_Insight: {
          pos: 3,
          label: 'Forecast Insight',
          def: 'Providing detail and additional insight on our digital transformation Use Case and technology forecasts.',
        },
        Webinar: {
          pos: 4,
          label: 'On-Demand Insights',
          def: 'Videos, webinars and podcasts featuring Transforma Insights analysts and other industry experts.',
        },

        // 2022-03-31: these 2 types were merged into "Key Topic Insight"
        // Tech_Insights: {
        //   pos: 0,
        //   label: 'Technology Insight',
        //   def: 'Provide a guide to the twelve technology families upon which we focus.',
        // },
        // Case_Study_Insight: {
        //   pos: 2,
        //   label: 'Case Study Insight',
        //   def: 'Analyse the information in the Best Practice & Vendor Selection Database.',
        // },
      },
      technology: {
        All: { label: 'Technology: All', pos: -1 },
        '3P': { label: '3D Printing and Additive Manufacturing', pos: 0 },
        AI: { label: 'Artificial Intelligence', pos: 1 },
        AV: { label: 'Autonomous Robotic Systems', pos: 2 },
        DS: { label: 'Data Sharing', pos: 3 },
        DL: { label: 'Distributed Ledger', pos: 4 },
        EC: { label: 'Edge Computing', pos: 5 },
        FT: { label: 'Future Technologies', pos: 6 },
        HM: { label: 'Human Machine Interface', pos: 7 },
        HC: { label: 'Hyperconnectivity', pos: 8 },
        IT: { label: 'Internet of Things', pos: 9 },
        PL: { label: 'Product Lifecycle Management', pos: 10 },
        RP: { label: 'Robotic Process Automation', pos: 11 },
      },
      sector: {
        All: { label: 'Vertical: All', pos: -1 },
        VA0: { label: 'Agriculture, Forestry & Fishing', pos: 0 },
        VB: { label: 'Mining & Quarrying', pos: 1 },
        VC: { label: 'Manufacturing', pos: 2 },
        VD: { label: 'Electricity, Gas, Steam & A/C', pos: 3 },
        VE: { label: 'Water Supply & Waste Management', pos: 4 },
        VF: { label: 'Construction', pos: 5 },
        VG: { label: 'Retail & Wholesale', pos: 6 },
        VH: { label: 'Transportation & Storage', pos: 7 },
        VI: { label: 'Accommodation & Food Service', pos: 8 },
        VJ: { label: 'Information & Communication', pos: 9 },
        VK: { label: 'Finance & Insurance', pos: 10 },
        VL: { label: 'Real Estate', pos: 11 },
        VM: { label: 'Professional, Scientific & Technical', pos: 12 },
        VN: { label: 'Administrative', pos: 13 },
        VO: { label: 'Government', pos: 14 },
        VP: { label: 'Education', pos: 15 },
        VQ: { label: 'Health & Social Care', pos: 16 },
        VR: { label: 'Arts & Entertainment', pos: 17 },
        VS: { label: 'Other Services', pos: 18 },
        VCON: { label: 'Consumer', pos: 19 },
      },
      region: {
        All: { label: 'Region: All', pos: -1 },
        Australasia: { label: 'Australasia', pos: 0 },
        Europe: { label: 'Europe', pos: 1 },
        'Greater China': { label: 'Greater China', pos: 2 },
        'India and South Asia': { label: 'India & South Asia', pos: 3 },
        Japan: { label: 'Japan', pos: 4 },
        'Latin America': { label: 'Latin America', pos: 5 },
        MENA: { label: 'MENA', pos: 6 },
        'North America': { label: 'North America', pos: 7 },
        'Russia & Central Asia': { label: 'Russia & Central Asia', pos: 8 },
        'South East Asia': { label: 'South East Asia', pos: 9 },
        'South Korea': { label: 'South Korea', pos: 10 },
        'Sub-Saharan Africa': { label: 'Sub-Saharan Africa', pos: 11 },
      },
    },
  },

  getters: {
  },

  mutations: {
    setIntro(state, payload) {
      Vue.set(state, 'intro', payload);
    },

    setAccessible(state, payload) {
      Vue.set(state, 'accessible', payload);
    },
    setTiGroup(state, payload) {
      Vue.set(state, 'tiGroup', payload);
    },
    setEnhanced(state, payload) {
      Vue.set(state, 'enhanced', payload);
    },

    initReports(state, payload) {
      Vue.set(state, 'reports', payload);
    },

    setPage(state, page) {
      state.page = page;
    },

    setTerms(state, payload) {
      state.terms = payload;
      if (state.terms.length === 0) {
        state.orderBy = 'date';
      }
    },

    setOrder(state, payload) {
      state.orderBy = payload;
    },

    setReport(state, payload) {
      Vue.set(state, 'detail', payload);
    },

    toggleFilter(state, payload) {
      const { cat, id } = payload;
      if (id === null) { // delete all from category
        state.filters[cat] = {};
      } else if (state.filters[cat][id]) {
        Vue.delete(state.filters[cat], id);
      } else {
        Vue.set(state.filters[cat], id, true);
      }
    },
  },
});


const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/research/reports' : '/rp',

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },

  routes: [
    {
      path: '/',
      name: 'report-list',
      component: ReportList,
    },
    {
      path: '/:slug',
      name: 'report-detail',
      component: ReportDetail,
    },
  ],
});

router.afterEach((to, from) => {
  // GA track page view
  // If `from` is null, this is initial page
  // tracking already sent on page load.
  if (window.GA_ID !== undefined && from.name !== null) {
    // console.log('route:', from, router.options.base, to);
    gtag('config', window.GA_ID, {
      page_title: to.name,
      page_path: router.options.base + to.path,
    });
  }
});


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
